import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
import Icon from "./Icon";

function FAQ() {
  const [openRow, setOpenRow] = useState(0);

  const toggleRow = (index) => {
    setOpenRow(openRow === index ? null : index);
  };

  const rows = [
    {
      name: "Мога ли да взема записа си веднага след като приключа снимането?",
      content:
        "Да. Благодарение на иновативната техника, с която разполага студиото, вашето живо предаване се записва на момента и можете да ползвате суровия материал веднага.",
    },
    {
      name: "За колко души е предназначено студиото",
      content: "4 човека",
    },
    {
      name: "Мога ли да донеса собствена техника?",
      content: "Може, нямаме такива ограничения.",
    },
    {
      name: "Предлагате ли помощ при настройката на осветление и звук?",
      content:
        "За всички настройки на видео, аудио и осветление можете да разчитате на оператор на място, който ще съдейства с всичко необходимо.",
    },
    {
      name: "Може ли да снимаме с няколко камери едновременно?",
      content:
        "Студиото разполага с 3 камери, които са налични по всяко време.",
    },
    {
      name: "Как мога да направя резервация?",
      content:
        "Можете директно да ни се обадите на посочените телефони както и да пратите запитване по имейл",
    },
    {
      name: "Мога ли да отменя или преместя резервацията си?",
      content:
        "При извънредни случаи можем да съдействаме с промяна на деня или часа",
    },
    {
      name: "Какви са начините на плащане?",
      content: "Можете да заплатите в брой или по банков път",
    },
  ];

  return (
    <div className="page_width flex flex-wrap items-start justify-between">
        {rows.map((row, index) => (
          <div
            key={index}
            className="shadow-md cursor-pointer w-full lg:w-[calc(50%-8px)] rounded-xl px-6 py-5"
            onClick={() => toggleRow(index)}
          >
            <div className="flex justify-between items-center gap-1">
              <h3 className="text-lg font-bold flex-1">{row.name}</h3>
              <Icon iconName="plus" className={`text-2xl transition-all duration-300 ${ openRow === index?"rotate-45":""}`}/>
            </div>
            <AnimatePresence>
              {openRow === index && (
                <motion.div
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  className="overflow-hidden"
                >
                  <p className="text-sm mt-2">{row.content}</p>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        ))}
    </div>
  );
}

export default FAQ;
